<template>
<div>
    <div class="electronic-certificate-box zj-box box-shadow">
        <div class="zj-infor">
            <p class="section">
                <span class="label">姓名</span>
                <span class="content">刘璇</span>
            </p>
            <div class="section-box">
                <p class="section">
                    <span class="label">性别</span>
                    <span class="content">女</span>
                </p>
                <p class="section">
                    <span class="label">民族</span>
                    <span class="content">汉族</span>
                </p>
            </div>
            <p class="section">
                <span class="label">出生日期</span>
                <span class="label birth-date"><span class="content">1990</span>年<span class="content">10</span>月<span class="content">26</span>日</span>
            </p>
            <p class="section">
                <span class="label">公民身份号码</span>
                <span class="content">321281999010010895</span>
            </p>
            <p class="section zzj-address">
                <span class="label">户籍地址</span>
                <span class="content">湖北省武汉市江岸区百步亭花园9幢207室</span>
            </p>
            <p class="section zzj-serial-number">
                <span class="label">编号</span>
                <span class="content" style="height:.34rem;line-height:.34rem;">520115201550000848</span>
            </p>
        </div>
        <div class="should-reads">
            <p class="section zzj-address">
                <span class="label">现居住地地址</span>
                <span class="content">湖北省武汉市汉阳区鹦鹉大道  446号407室</span>
            </p>
            <p class="section">
                <span class="label">签发机关</span>
                <span class="content">湖北省武汉市公安局江岸分局</span>
            </p>
            <div class="issue-date">
                <p class="section">
                    <span class="label">签发日期</span>
                    <span class="content">2015年06月24日</span>
                </p>
                <p class="section">
                    <span class="label">有效期限 <span class="year-color">5</span> 年</span>
                </p>
            </div>
        </div>
        <img class="photo" src="~@public/img/user/electronicCertificate/photo.jpg" alt="照片">
    </div>
<!--     说明按钮-->
    <p class="instructions-btn">使用说明</p>
    <!-- 弹窗 -->
    <div class="popup">
        <i class="popup-btn"></i>
        <div class="img-box">
            <a href="#" @click="wangba">
                <img class="img-one" src="~@public/img/user/electronicCertificate/lscjzm.png" alt="图片">
            </a>
        </div>
    </div>
    <van-dialog v-model="show" class="dialog-demo">
        <p style="text-align: left;margin-top: 10px;padding-left: 15px">二维码信息：</p>
       <div class="img-box">
            <img src="~@public/img/user/electronicCertificate/ewm.png" style="width: 100%">
        </div>
        <p style="text-align: left;padding: 0 15px;font-size: 12px">(该二维码仅在湖北省内机场乘机时使用有效)</p>
    </van-dialog>
</div>
</template>

<script>
   import { Dialog} from 'vant';
    export default {
        components: {
            [Dialog.Component.name]: Dialog.Component
        },
        data() {
            return {
                show: false
            };
        },
        beforeRouteLeave(to, from, next) {
            if (to.path === '/sign-up/login' && this.$store.state.loginStatus) {
                next('/electronicCertificate')
            }
            next()
        },
        methods:{
            wangba:function() {
                this.show=true

            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/user/electronicCertificate/reset.less";
    @import "~@assets/css/views/user/electronicCertificate/FlightCertificate.less";

</style>
<style>
  .weui-dialog{
    width: 75% !important;
    height: 310px !important;
  }
  .van-dialog{
      top:48%;
      width: 74%;
  }

</style>
